import React from 'react'
import './element-preview-item.styles.scss'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { properCase } from '@/utils/properCase'
import ElementAttributesPreview from '@/components/SHARED/element-attributes-preview/element-attributes-preview'

const ElementPreviewItem = ({
  gameData,
  keyId,
  element
}) => {
  return (
    <div
      key={keyId}
      className='element-preview-item'>
      <hr />
      <div className='game-preview-element-head'>
        <ImageContainer
          src={element.icon}
          className={'game-preview-element-icon'}
          preview={true} />
        <div className='game-preview-element-name-container'>
          <div className='game-preview-element-name'>
            {element.name}
          </div>
          <div className='meta'>
            <span className='meta-type'>{properCase(element.type)}</span>
          </div>
        </div>
      </div>
      
      {
        (element.desc) &&
        <>
          <div className="g-space-1"></div>
          <div className='meta'>Description:</div>
          <div style={{"color": gameData?.color}} dangerouslySetInnerHTML={{__html: element.desc}}></div>
          <div className='g-space-0-5'></div>
        </>
      }
      <ElementAttributesPreview
        element={element} />
    </div>
  )
}

export default ElementPreviewItem